import { NotebookPen } from "lucide-react";
import { JOURNAL_LALA_STATES, JOURNAL_LALA_ACTION_KEYS, journalLalaAction, journalLalaCopy } from "../journalLalaSetting.js";
import { t } from "../strings.js";

// LALA-BRAIN-1 CLAUSE 2 — **THE PANEL SHE READS AND THE ONE CONTROL SHE TAPS.**
//
// Hookless (R7/R8's entry requirement), so `scripts/lala-brain-journal.mjs` CALLS it once per state
// and reads the tree back. The state and the round trip live in `JournalLalaSetting.tsx`, which is
// `DailyLineSetting`/`DailyLineSettingPanel`'s split one preference over.
//
// **THE SECOND LINE IS THE WHOLE POINT OF THIS CONTROL EXISTING.** Her order widens Lala's reach
// across everything a member owns, and this is the one place inside that widening where she wrote a
// door OUT: *"their journal entries IF the member's journal is not marked private-from-Lala."* So the
// note says what the switch governs and what it does NOT — turning this off does not delete a word
// of her journal and does not close anything else.
export function JournalLalaSettingPanel({
  state, busy = false, note = "", language = "en", onAct,
}: {
  state: string;
  busy?: boolean;
  note?: string;
  language?: string;
  onAct: (action: string) => void;
}) {
  const action = journalLalaAction(state);
  return (
    <div className={`push-settings journal-lala journal-lala--${state}`}>
      <h3 className="push-settings__head">
        <NotebookPen size={15} aria-hidden="true" />
        {" "}{t(language, "journal.lala.heading")}
      </h3>
      <p className="push-settings__state">{t(language, journalLalaCopy(state))}</p>
      {/* Drawn on both real states and NOT while the setting is still unknown: a scope note beside a
          state nobody has read yet is reassurance about something that has not been said (R18). */}
      {state === JOURNAL_LALA_STATES.UNKNOWN ? null : (
        <p className="push-settings__note">{t(language, "journal.lala.note")}</p>
      )}
      {action ? (
        <button
          type="button"
          className={`push-settings__act journal-lala__act--${action}`}
          onClick={() => onAct(action)}
          disabled={busy}
        >
          {busy ? t(language, "journal.lala.working") : t(language, JOURNAL_LALA_ACTION_KEYS[action])}
        </button>
      ) : null}
      {/* R47/R53/R61: the answer is READ and a refusal is SAID. A control that swallows its own
          failure leaves a truthful-looking screen, which is the one shape nobody reports. */}
      {note ? <p className="push-settings__note push-settings__note--warn">{note}</p> : null}
    </div>
  );
}
